import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { Address } from "../../../../redux/apiSpecifications/apiSubjects";
import { InputTextStyled } from "../../../../style/Input";
import { toFullAddress } from "../../../../utils/address";
import { IconButtonWithConfirm } from "../../../Inputs/IconButtons";
import { IconPracticesRejected } from "../../../../config/icons";
import { FormRow } from "../../../../style/form";
import dekra from "../../../../style/dekra";
import { SubjectAddressModal } from "./SubjectAddressForm";
import { useState } from "react";

const SubjectAddessesFormWrapper = styled.div`
  .ant-input[disabled] {
    color: rgba(0, 0, 0, 0.25);
    background-color: rgb(255, 255, 255);
    border-color: #d9d9d9;
    box-shadow: none;
    cursor: not-allowed;
    opacity: 1;
  }

  .edit-allowed {
    cursor: pointer !important;
  }
`;

const SubjectAddessesFormRow = styled(FormRow)`
  .field {
    width: 100%;
  }

  .button {
    // color: red;
    color: ${dekra.primaryColor};
    margin-top: auto;
    margin-bottom: 10px;

    // div {
    //   height: 32px;
    // }
  }
`;

interface ISubjectAddessesFormProps {
  addresses?: Address[] | undefined;
  disableForm?: boolean;
  onEditAddress?: (address: Address) => void;
  onDeleteAddress?: (address: Address) => void;
}

const SubjectAddessesForm = ({
  addresses = [],
  disableForm = false,
  onEditAddress,
  onDeleteAddress,
}: ISubjectAddessesFormProps) => {
  const { t } = useTranslation();

  const [subjectAddress, setSubjectAddress] = useState<Address | undefined>(
    undefined
  );

  const handleOnConfirmSubjectAddress = (address: Address) => {
    setSubjectAddress(undefined);

    if (onEditAddress) onEditAddress(address);
  };

  // const handleOnEditAddress = (address: Address) => {
  //   if (onEditAddress) onEditAddress(address);
  // };

  const handleOnDeleteAddress = (address: Address) => {
    if (onDeleteAddress) onDeleteAddress(address);
  };

  const homeAddress = addresses.find((_) => _.type === "D");
  const residenceAddress = addresses.find((_) => _.type === "R");
  const registeredOffice = addresses.find((_) => _.type === "L");

  return (
    <>
      <SubjectAddessesFormWrapper>
        <SubjectAddessesFormRow>
          <div className="field">
            <InputTextStyled
              classNameInput={disableForm ? "edit-disallowed" : "edit-allowed"}
              label={t("LABELS.home-address")}
              placeholder={t("PLACEHOLDERS.home-address")}
              value={toFullAddress(homeAddress)}
              readOnly={true}
              disabled={disableForm}
              onClick={() => setSubjectAddress(homeAddress || { type: "D" })}
            />
          </div>

          <div className="button">
            <IconButtonWithConfirm
              onClick={
                homeAddress && disableForm === false
                  ? () => handleOnDeleteAddress(homeAddress)
                  : undefined
              }
              popconfirmOption={{
                title: t("MESSAGES.confirm-delete-subject-address")!,
                placement: "leftTop",
              }}
            >
              <IconPracticesRejected />
            </IconButtonWithConfirm>
          </div>
        </SubjectAddessesFormRow>

        <SubjectAddessesFormRow>
          <div className="field">
            <InputTextStyled
              classNameInput={disableForm ? "edit-disallowed" : "edit-allowed"}
              label={t("LABELS.residence-address")}
              placeholder={t("PLACEHOLDERS.residence-address")}
              value={toFullAddress(residenceAddress)}
              readOnly={true}
              disabled={disableForm}
              onClick={(e) => {
                setSubjectAddress(residenceAddress || { type: "R" });
              }}
            />
          </div>

          <div className="button">
            <IconButtonWithConfirm
              onClick={
                residenceAddress && disableForm === false
                  ? () => handleOnDeleteAddress(residenceAddress)
                  : undefined
              }
              popconfirmOption={{
                title: t("MESSAGES.confirm-delete-subject-address")!,
                placement: "leftTop",
              }}
            >
              <IconPracticesRejected />
            </IconButtonWithConfirm>
          </div>
        </SubjectAddessesFormRow>

        <SubjectAddessesFormRow>
          <div className="field">
            <InputTextStyled
              classNameInput={disableForm ? "edit-disallowed" : "edit-allowed"}
              label={t("LABELS.registered-office-address")}
              placeholder={t("PLACEHOLDERS.registered-office-address")}
              readOnly={true}
              value={toFullAddress(registeredOffice)}
              disabled={disableForm}
              onClick={() =>
                setSubjectAddress(registeredOffice || { type: "L" })
              }
            />
          </div>

          <div className="button">
            <IconButtonWithConfirm
              onClick={
                registeredOffice && disableForm === false
                  ? () => handleOnDeleteAddress(registeredOffice)
                  : undefined
              }
              popconfirmOption={{
                title: t("MESSAGES.confirm-delete-subject-address")!,
                placement: "leftTop",
              }}
            >
              <IconPracticesRejected />
            </IconButtonWithConfirm>
          </div>
        </SubjectAddessesFormRow>
      </SubjectAddessesFormWrapper>

      <SubjectAddressModal
        open={subjectAddress !== undefined}
        address={subjectAddress}
        onCancel={() => setSubjectAddress(undefined)}
        onConfirm={handleOnConfirmSubjectAddress}
      />
    </>
  );
};

export default SubjectAddessesForm;
